import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { INotificacaoSistema } from '../interfaces/INotificacaoSistema';
import MensagensService from '../services/MensagensService';

interface INotificacaoContext {
    notifications: INotificacaoSistema[],
    removeNotification: Function
    removeAllNotification: Function,
}

const NotificacaoContext = createContext<INotificacaoContext | null>(null);

export const NotificacaoProvider = ({ children }: any) => {
    const [notifications, setNotifications] = useState<INotificacaoSistema[]>([]);


    useEffect(() => {
        setInterval(() => {
            MensagensService.listarMensagensSistema().then((resp) => {
                setNotifications((old) => {
                    return resp;
                });
            });
        }, 600000);
    }, []);

    const removeNotification = useCallback((id: number) => {
        setNotifications((old) => {
            return old.filter((f) => f.id !== id);
        });

        MensagensService.visualizarMensagem(id);
    }, []);

    const removeAllNotification = useCallback(() => {
        setNotifications([]);

        MensagensService.visualizarTodas();
    }, []);



    return (
        <NotificacaoContext.Provider value={{ notifications, removeNotification, removeAllNotification }}>
            {children}
        </NotificacaoContext.Provider>
    )
}

export function useNotify() {
    const context = useContext<INotificacaoContext | any>(NotificacaoContext);

    return context as INotificacaoContext;
}